<template>
  <div class="container lms-wrapper-two">

    <researcher-nav @do-logout="logout" />

    <div class="lms-content" @click="closeLevel2()">
      <stf-header class="filled" ref="lmsv4header" />
      <div v-if="mode==10" class="lms-content-body" style="height: calc(100vh - 140px); overflow: auto">
        <div class="wd-100p pd-t-20">
          <table class="table table-bordered table-striped">
            <thead class="thead-primary">
              <tr>
                <th>Д/д</th>
                <th>Хуулийн этгээдийн нэр</th>
                <th>Регистрийн дугаар</th>
                <th v-if="hasPermission(['stf_ubeg'])">Инновацийн төслийн нэр</th>
                <th v-else>Бүтээгдэхүүн, ажил, үйлчилгээний нэр</th>
                <th>Төсөл хэрэгжүүлэх хугацаа</th>
                <th>Цуцалсан шалтгаан</th>
              </tr>
            </thead>
            <tbody>
              <tr  v-for="(l, i) in list" :key="i">
                <td>{{ i+1 }}</td>
                <td>{{ l.companyTask.name }}</td>
                <td>{{ l.companyTask.regNo }}</td>
                <td v-if="hasPermission(['stf_ubeg'])">{{ l.projectTask.task }}</td>
                <td v-else>{{ l.projectTask.s16 }}</td>
                <!-- <td>{{ l.zarTask.task }} ({{ l.zarTask.type.name }})</td> -->
                <td>
                  <span class="d-block text-muted text-right"
                    >{{ l.zarTask.d3 | moment("YYYY.MM.DD") }} -
                    {{ l.zarTask.d4 | moment("YYYY.MM.DD") }}</span>
                </td>
                <td>
                  {{ l.projectTask.s15 }}
                  <a class="btn btn-xs btn-white" @click="showAttach(l.projectTask.fourthAttachmentId)">файл харах</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="lms-content-body" style="height: calc(100vh - 140px); overflow: auto">

        <div v-if="fetched && courses.length<=0" class="container ht-100p text-center">
          
          <div class="ht-100p d-flex flex-column align-items-center justify-content-center">
            <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
              <!-- <img src="../../assets/img/img21.png" class="img-fluid" alt=""> -->
            </div>
            <h5 class="tx-16 tx-sm-18 tx-lg-20 tx-normal mg-b-20">Мэдээлэл олдсонгүй</h5>
            <p v-if="mode==0 || mode==1 " class="tx-color-03 mg-b-30"></p>
            <p v-else-if="mode==2" class="tx-color-03 mg-b-30">Танд одоогоор оролцсон төсөл алга байна</p>
            <p v-else-if="mode==3" class="tx-color-03 mg-b-30">Танд одоогоор материал илгээсэн төсөл алга байна</p>
            <p v-else-if="mode==4" class="tx-color-03 mg-b-30">Танд одоогоор санхүүжилт авсан төсөл алга байна</p>
            <div class="mg-b-40"><button @click="$router.push({name: 'stfResearcher'})" class="btn btn-white bd-2 pd-x-30">Эхлэл</button></div>

          </div>

        </div>
        <vue-custom-scrollbar v-else-if="courses.length" class="course-list pd-t-20-f pd-lg-x-80 pd-lg-xl-120 row">
          <div v-for="(r, ci) in courses" :key="`${ci}_v4`"
            class="course-item col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3 pd-10">
            
            <div class="bg-white pd-15 rounded-20 item-outer pos-relative">
              <div class="bg-gray-500 course-tag pos-absolute r-0 b-0 text-white pd-x-20 pd-y-1 tx-14"> {{ getItemFlag(r) }} </div>
            <div class="tx-18">
              {{ r.task }}
            </div>
            <!-- <img
                src="https://cdn.gosmart.mn/1CwVzESJi02bf48yzUFpWw/cf7a53d4-1a2e-4890-90c6-87915b3a6a4f/DynamicOffice/2.jpg?w=400&amp;h=280&amp;mode=crop"
                class="cover rounded-20 wd-100p "> -->
              <div class="item-info pd-10 d-flex align-items-center bd-3 bd-l mg-t-10">
                <div class="media-body">
                  <div title="" class="course-name tx-13 font-weight-bold lh-1">
                    {{ mode==3?r.organizationTask.task : r.locTypeName }}
                  </div>
                  <!---->
                  <div class="d-flex">
                    <div>
                      <div class="mg-t-10">{{mode==3 || mode==4?'Эхлэх дуусах':'Материал хүлээн авах'}}</div>
                      <div class="tx-14 text-muted">{{ r.d1 | moment('YYYYоны MM-р сарын DD-ны HH:mm-c') }}</div>
                      <div class="tx-14 text-muted">{{ r.d2 | moment('YYYYоны MM-р сарын DD-ны HH:mm хүртэл') }}</div>
                    </div>

                    <div class="d-flex">
                      <div></div>
                      <div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="course-view justify-content-center align-items-center mg-l-auto ">
                <div class="btn-group rounded-20">
                  <router-link :to="{name: mode==3 || mode==4|| mode==5?'stfAdApply':'stfAdDetail' ,params:{ id: mode==3 || mode==4 || mode==5 ? r.organizationTaskId : r.id } }"
                    class="btn btn-white ">Дэлгэрэнгүй</router-link>
                </div>
              </div>
            </div>
          </div>



        </vue-custom-scrollbar>
      </div>

      <div v-if="mode!=10" class="lms-content-footer">
        <div class="font-weight-bold pd-l-20 tx-16 d-none d-md-block ">Нийт {{courses.length}} зар</div>
        <div class="d-flex align-items-center">
          <div class="mg-r-10">
            <loc-type-cascader @input="doFilter($event)" placeholder="Төрлөөр хайх"
            locTypekey="stf_projectType" size="small" disableAdd class="wd-100p-f" />
          </div>
        </div>
        <div class="pd-r-10">
          <!-- <a @click="filterParams.sideBar=true" class="btn btn-brand-02 rounded-20 text-white"><feather type="filter"></feather> шүүх</a> -->
        </div>
      </div>


    </div>

    <div>



    </div>

    <file-dialog
        :show="fileDialog.show"
        :id="fileDialog.id"
        @on-hide="fileDialog.show = false"
      />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

import { hasOneOf } from "@/libs/tools";  

export default {
  components: {
    vueCustomScrollbar,
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    researcherNav: () => ({
      component: import("@/views/home/apps/stf/researcher/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    stfHeader: () => ({
      component: import("@/views/home/apps/stf/researcher/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {  
    return {
      fileDialog: {
        id: null,
        show: false,
      },
      list: [],
      fetched: false,
      mode: null,
      allCount: null,
      courses: [],
      filterDta:{
        isPublic: null,
        locTypeId: null,
        i8: null,//me accepted
        isCompleted: null, //sanhuujilt avsniig end hadgalthaar tuluvlusun,
        userId: '00000000-0000-0000-0000-000000000000'//guid
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    showAttach(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    getItemFlag(proj){
      let rv= '';
      
      return rv;
    },
    logout() {
      this.$refs.lmsv4header.logout();
    },
    searchHandler() {
      console.log('srch handled');
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig", 'handleLoading']),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
      //console.log(shown, this.navbarMode);
    },
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    doFilter(e){
      console.log('doFilter=>', e);
      this.filterDta.locTypeId= e;
      this.init();
    },
    initYam(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "ProjectEdu/GetMyAssignedProjects" },
        params: {
          status: 10,
        },

        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          console.log(' res.data',  res.data);
          this.list = res.data.list;
        }
      });
    },
    init() {
      this.mode= parseInt(this.$route.params.type, 10);  
      if(this.mode==10){
        this.initYam();
        // this.fetched= true;
      }
      else{
        this.fetched=false;
        this.handleLoading({ isLoading: true });
        let _dta={};

        //if(this.$route.params.type==1)

        let _lt=null;
        if(this.$store.state.user.userInfo.qualityPerc!=undefined && this.$store.state.user.userInfo.qualityPerc!=null
        && this.$store.state.user.userInfo.qualityPerc>0){
          _lt= [251286, 162068];
        }

        
        switch(this.mode){
          case 0:
          case 1:
            this.filterDta.isPublic= true; 
            //this.filterDta.locTypeId= _lt; 
            this.filterDta.locTypeIdMulti= _lt; 
            break;
          case 3:
            this.filterDta.i8= -1;
            this.filterDta.userId= this.$store.state.user.userId; 
            break;
          case 4:
            this.filterDta.i8= 1;
            this.filterDta.userId= this.$store.state.user.userId; 
            break;
          case 5:
            //this.filterDta.i8= 2; break;
            this.filterDta.isCompleted= true;
            this.filterDta.userId= this.$store.state.user.userId; 
          default: break;
        }

        request({
          // api: { method: "POST", url: "v2/learn/studentHomeData" },
          api: { method: "POST", url: "TaskCore/GetCoreList" },
          data: {
            skip: 0,
            size: 100,
            ot: (this.mode==3 || this.mode==4 || this.mode==5) ? 561 :  560,
            model: this.filterDta
          },
          store: this.$store,
        }).then((res) => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            //allCount
            //console.log('res', res);
            this.fetched= true;
            this.courses = res.data.tasks;
          }
        });

        let _learnExamRegistration = this.getConfigValueByKey(
          "learnExamRegistration"
        );
        if (this.$store.state.app.activeGroup.id == 6126) {
          if (this.$store.state.user.userInfo.locType4Code != "member") {
            this.learnExamRegistration = parseInt(_learnExamRegistration, 10);
          }
        } else {
          this.learnExamRegistration = parseInt(_learnExamRegistration, 10);
        }
      }
    },
  },
  watch: {
    "$root.$route"() {
      //console.log(newRoute);
      Object.assign(this.$data, this.$options.data());
      this.$nextTick(() => {
        this.init();
      });
    }
  }
};
</script>
